/* eslint-disable max-len,eqeqeq,no-mixed-operators */

import _remove from 'lodash/remove';
// eslint-disable-next-line import/no-extraneous-dependencies
import debug from 'webmd-debug';
import useStore from "@/useStore";

// eslint-disable-next-line consistent-return
function getPageData(vm) {
	const { pagedata } = vm.$options;
	if (pagedata) {
		return typeof pagedata === 'function' ? pagedata.call(vm) : pagedata;
	}
}

function isTugActive(startDate, endDate) {
	const today = new Date().getTime();
	const from = new Date(startDate).getTime();

	// adding +1 day to include the end date
	const to = new Date(endDate).getTime() + 1000 * 60 * 60 * 24;

	if (today >= from && today <= to) {
		return true;
	}

	return false;
}

// eslint-disable-next-line no-unused-vars
function ifCommon(arr1, arr2) {
	return arr1.some((item) => arr2.includes(item));
}

const serverPageDataMixin = {
	created() {
	   this.store = useStore(this.$pinia);
		if (this.$ssrContext) {
			const pagedata = getPageData(this);
			if (pagedata) {
				this.$ssrContext.pagedata = pagedata;
			}
		}
	},
	// eslint-disable-next-line consistent-return
	beforeMount() {
		this.setPageData();
	},
	mounted() {
		const self = this;

		try {
			const pagedata = getPageData(this);
			if (document) {
				if (pagedata) {
					document.title = pagedata.meta.page_title;
				}
			}
			// eslint-disable-next-line no-empty
		} catch (err) {
		}

		if (!window.pagedataEventBound) {
			window.pagedataEventBound = true;

			document.addEventListener('webmd.pagedata.reset', () => {
				debug('resetting page data');
				self.setPageData(true);
			});
		}
	},

	methods: {
		// eslint-disable-next-line consistent-return
		setPageData(force) {
			if (this && this.$pinia && this.store && this.store.pagedata && ((window && !window.s_tug && !window.tugsEvaluated) || force)) {
				debug(`[Tugs-Pugs] Found window.s_tug as ${window.s_tug} and tugsEvaluated as ${window.tugsEvaluated}. So starting tugs evaluation...`);
				const { pagedata } = this.store;

				if (pagedata && pagedata.tugs && Array.isArray(pagedata.tugs) && pagedata.tugs.length > 0) {
					debug('[Tugs-Pugs] Some tugs are associated with this page...');
					let gtinfoCookie = {};
					if (document.cookie && document.cookie.indexOf('gtinfo=') !== -1) {
						const match = document.cookie.match(new RegExp('(^| )gtinfo=([^;]+)'));
						if (match) {
							gtinfoCookie = JSON.parse(match[2]);
						}
					}

					debug('[Tugs-Pugs] Evaluated gtinfoCookie =', gtinfoCookie);

					let resolvedTugs = [];
					let resolvedPugs = [];
					let resolvedTug = {};

					if (gtinfoCookie) {
						/**
						 * Resolved tugs are active tugs. Also,
						 * If its geoenabled, then it should match the geolocation(dma,sc,cntrc) of the user.
						 */

						resolvedTugs = pagedata.tugs.filter((t) => isTugActive(t.startdate, t.enddate) && t.geoEnabled === 'false');

						if (resolvedTugs.length < 1) {
							debug('[Tugs-Pugs] Did NOT find any active non geo-targeted campaigns. Filtering out active tugs...');

							resolvedTugs = pagedata.tugs.filter((t) => (isTugActive(t.startdate, t.enddate)));

							debug('[Tugs-Pugs] Filtered Active tugs', resolvedTugs);

							const dmaTargettedTugs = resolvedTugs.filter((t) => t.dma !== 'none' && t.dma.split('_').includes(gtinfoCookie.dma));

							debug('[Tugs-Pugs] dma targetted campaigns', dmaTargettedTugs);

							if (dmaTargettedTugs.length > 0) {
								resolvedTugs = dmaTargettedTugs;
							} else {
								const scAndCntrcExactMatchTugs = resolvedTugs.filter((t) => t.sc.split('_').includes(gtinfoCookie.sc) && t.cntrc.split('_').includes(gtinfoCookie.cntrc));
								debug('[Tugs-Pugs] sc and cntrc exact targetted campaigns', scAndCntrcExactMatchTugs);

								if (scAndCntrcExactMatchTugs.length > 0) {
									resolvedTugs = scAndCntrcExactMatchTugs;
									debug('[Tugs-Pugs] found sc and cntrc exact targetted campaigns', scAndCntrcExactMatchTugs);
								} else {
									const onlyCntrc = resolvedTugs.filter((t) => t.sc === 'none' && t.dma == 'none' && t.cntrc.split('_').includes(gtinfoCookie.cntrc));
									debug('[Tugs-Pugs] cntrc exact targetted campaigns', onlyCntrc);
									if (onlyCntrc.length > 0) {
										resolvedTugs = onlyCntrc;
									} else {
										const onlyActive = resolvedTugs.filter((t) => t.sc === 'none' && t.dma == 'none' && t.cntrc == 'none');
										debug('[Tugs-Pugs] only active open targetted campaigns', onlyActive);
										if (onlyActive.length > 0) {
											resolvedTugs = onlyActive;
										} else {
											resolvedTugs = [];
										}
									}
								}
							}

							// eslint-disable-next-line max-len

							// eslint-disable-next-line no-restricted-syntax
							debug('[Tugs-Pugs] after geo targetting', resolvedTugs);

							debug('[Tugs-Pugs] List of active geo-target match campaigns before applying exclusions: ', resolvedTugs);

							/**
							 * After resolving the tugs.
							 * Below we are filtering out the tugs that are from the excluded zone.
							 * So, if the user's location matches excluded zone. Discard those tugs.
							 */
							if (resolvedTugs.length > 0
								&& pagedata.tugs.length > 0
								&& (pagedata.tugs[0].xdma || pagedata.tugs[0].xsc)) {
								_remove(resolvedTugs, (t) => (t.xdma.split('_').includes(gtinfoCookie.dma) && t.xdma !== 'none') || (t.xsc.split('_').includes(gtinfoCookie.sc) && t.xsc !== 'none'));
							}

							debug('[Tugs-Pugs] List of active geo-target match campaigns after applying exclusions', resolvedTugs);
						} else {
							debug('[Tugs-Pugs] Found an active campaign which is non-geo targeted.');
						}

						/**
						 * Finally just select 1 tug from the list
						 */
						if (resolvedTugs && resolvedTugs.length > 0) {
							// eslint-disable-next-line prefer-destructuring
							resolvedTug = resolvedTugs[0];
						}
						debug('[Tugs-Pugs] Final Tug', resolvedTug);
					}

					resolvedPugs = pagedata.tugs.filter((t) => (!isTugActive(t.startdate, t.enddate)));

					debug('[Tugs-Pugs] List of resolved pugs: ', resolvedPugs);

					if (resolvedPugs && resolvedPugs.length > 0) {
						const dmaTargettedPugs = resolvedPugs.filter((t) => t.dma !== 'none' && t.dma.split('_').includes(gtinfoCookie.dma));
						debug('[Tugs-Pugs] dma targetted pugs', dmaTargettedPugs);

						if (dmaTargettedPugs.length > 0) {
							resolvedPugs = dmaTargettedPugs;
						} else {
							const scAndCntrcExactMatchPugs = resolvedPugs.filter((t) => t.sc.split('_').includes(gtinfoCookie.sc) && t.cntrc.split('_').includes(gtinfoCookie.cntrc));
							debug('[Tugs-Pugs] sc and cntrc exact targetted pugs', scAndCntrcExactMatchPugs);

							if (scAndCntrcExactMatchPugs.length > 0) {
								resolvedPugs = scAndCntrcExactMatchPugs;
								debug('[Tugs-Pugs] found sc and cntrc exact targetted pugs', scAndCntrcExactMatchPugs);
							} else {
								const onlyCntrc = resolvedPugs.filter((t) => t.sc === 'none' && t.dma == 'none' && t.cntrc.split('_').includes(gtinfoCookie.cntrc));
								debug('[Tugs-Pugs] cntrc exact targetted pugs', onlyCntrc);
								if (onlyCntrc.length > 0) {
									resolvedPugs = onlyCntrc;
								} else {
									resolvedPugs = [];
								}
							}
						}

						resolvedPugs = [
							...pagedata.tugs.filter((t) => !isTugActive(t.startdate, t.enddate) && (t.geoEnabled === 'false' || (t.sc === 'none' && t.dma == 'none' && t.cntrc == 'none'))),
							...resolvedPugs,
						];

						debug('[Tugs-Pugs] List of matched pugs before applying exclusions: ', resolvedPugs);

						if (resolvedPugs.length > 0
							&& (resolvedPugs[0].xdma || resolvedPugs[0].xsc)) {
							_remove(resolvedPugs, (t) => (t.xdma.split('_').includes(gtinfoCookie.dma) && t.xdma !== 'none') || (t.xsc.split('_').includes(gtinfoCookie.sc) && t.xsc !== 'none'));
						}

						debug('[Tugs-Pugs] List of pugs after applying exclusions', resolvedPugs);
					}

					// }

					debug('[Tugs-Pugs] Final Pugs', resolvedPugs);

					if (Object.keys(resolvedTug).length > 0) {
						window.s_sponsor_brand = resolvedTug.brand;
						window.s_tug = resolvedTug.ID;
						window.s_sponsor_program = resolvedTug.program;
						window.s_package_type = resolvedTug.packagetype;
						pagedata.ad.targets.tug = resolvedTug.ID;
						pagedata.omniture.s_tug = resolvedTug.ID;
						pagedata.omniture.s_sponsor_brand = resolvedTug.brand;
						pagedata.omniture.s_sponsor_program = resolvedTug.program;
						pagedata.omniture.s_package_type = resolvedTug.packagetype;
					} else {
						window.s_sponsor_brand = '';
						window.s_tug = '';
						window.s_sponsor_program = '';
						window.s_package_type = '';

						pagedata.ad.targets.tug = '';
						pagedata.omniture.s_tug = '';
						pagedata.omniture.s_sponsor_brand = '';
						pagedata.omniture.s_sponsor_program = '';
						pagedata.omniture.s_package_type = '';
					}

					debug('[Tugs-Pugs] resolvedTug.brand is set into window.s_sponsor_brand. Value of window.s_sponsor_brand:', window.s_sponsor_brand);
					debug('[Tugs-Pugs] resolvedTug.ID is set into window.s_tug. Value of window.s_tug:', window.s_tug);
					debug('[Tugs-Pugs] resolvedTug.program is set into window.s_sponsor_program:', window.s_sponsor_program);
					debug('[Tugs-Pugs] resolvedTug.packagetype is set into window.s_package_type:', window.s_package_type);

					debug('[Tugs-Pugs] resolvedTug.ID is set into pagedata.ad.targets.tug. Value of pagedata.ad.targets.tug:', pagedata.ad.targets.tug);
					debug('[Tugs-Pugs] resolvedTug.ID is set into pagedata.omniture.s_tug. Value of pagedata.omniture.s_tug:', pagedata.omniture.s_tug);
					debug('[Tugs-Pugs] resolvedTug.brand is set into pagedata.omniture.s_sponsor_brand. Value of pagedata.omniture.s_sponsor_brand:', pagedata.omniture.s_sponsor_brand);
					debug('[Tugs-Pugs] resolvedTug.program is set into pagedata.omniture.s_sponsor_program. Value of pagedata.omniture.s_sponsor_program:', pagedata.omniture.s_sponsor_program);
					debug('[Tugs-Pugs] resolvedTug.packagetype is set into pagedata.omniture.s_package_type. . Value of pagedata.omniture.s_package_type:', pagedata.omniture.s_package_type);

					if (resolvedPugs.length > 0) {
						const resolvedPugsIDs = [];
						// eslint-disable-next-line array-callback-return
						resolvedPugs.every((pug) => {
							resolvedPugsIDs.push(pug.ID);
							return true;
						});

						/**
						 * Removed if any duplicates and join
						 */
						pagedata.ad.targets.pug = resolvedPugsIDs.filter((pugID, index) => resolvedPugsIDs.indexOf(pugID) === index).join(',');
					} else {
						pagedata.ad.targets.pug = '';
					}

					debug('[Tugs-Pugs] resolvedPugs.ID are concatenated and set into pagedata.ad.targets.pug. Value of pagedata.ad.targets.pug:', pagedata.ad.targets.pug);

					// eslint-disable-next-line no-underscore-dangle
					if (window && window.__INITIAL_STATE__ && window.__INITIAL_STATE__.pagedata) {
						// eslint-disable-next-line no-underscore-dangle
						window.__INITIAL_STATE__.pagedata = pagedata;
					}

					debug('[Tugs-Pugs] resolvedPugs.ID are concatenated into pagedata.ad.targets.pug. Value of pagedata.omniture.s_package_type:', pagedata.omniture.s_package_type);

					try {
						debug('[Tugs-Pugs] Setting window.tugsEvaluated as :', window.tugsEvaluated);

						/*
						 * marking that we have completed our analysis of tugs and pugs
						 * so that this whole logic doesn't execute on beforeMount() of every component.
						 * This variable can be set to false for reevaluating tugs/pugs during infinite scroll.
						 */
						window.tugsEvaluated = true;
						// Dispatch Tugs Evaluated
						window.document.dispatchEvent(new CustomEvent('wbmd:tugsEvaluated'));
						return this.store.cms.updatePagedata(pagedata);
						// eslint-disable-next-line no-empty
					} catch (err) {
						debug('[Tugs-Pugs] Problem with dispatching to cms/updatePagedata. Maybe cms/updatePagedata is not available.', err);
					}
				}

				/*
				 * marking that we have completed our analysis of tugs and pugs
				 * so that this whole logic doesn't execute on beforeMount() of every component.
				 * This variable can be set to false for reevaluating tugs/pugs during infinite scroll.
				 */
				window.tugsEvaluated = true;
				// Dispatch Tugs Evaluated
				window.document.dispatchEvent(new CustomEvent('wbmd:tugsEvaluated'));
			}
		},
	},
};

export default serverPageDataMixin;
